import { useMutation, useQuery } from 'react-query'
import { normalFetch } from '../../fetch-api/get'
import { putApi } from '../../fetch-api/put'
import { useQueryContext } from '../../../contexts/query'

export const accountingKeys = {
	getAccountingConfig: 'getAccountingConfig',
	setAccountingConfig: 'setAccountingConfig',
	setUserManualAccountingConfig: 'setUserManualAccountingConfig',
	getUserManualAccountingConfig: 'getUserManualAccountingConfig',
}

export const useGetAccountingConfig = () => {
	return useQuery({
		queryFn: () => normalFetch('settings/manualAccounting'),
		queryKey: [accountingKeys.getAccountingConfig],
		select: (res) => res?.data?.data,
	})
}

export const useSetAccountingConfig = (onSuccess) => {
	const { queryClient, setToast } = useQueryContext()

	return useMutation({
		mutationFn: (payload) => putApi(payload, 'settings/manualAccounting'),
		mutationKey: [accountingKeys.setAccountingConfig],
		onSuccess: () => {
			queryClient.invalidateQueries([accountingKeys.getAccountingConfig])
			setToast({
				message: 'operation-success',
				show: true,
			})
			onSuccess()
		},
	})
}

export const useUpdateUserManualAccountingConfig = (onSuccess) => {
	const { queryClient, setToast } = useQueryContext()

	return useMutation({
		mutationFn: (payload) => putApi(payload.data, `banking/manual/admin/config/${payload.userId}`),
		mutationKey: [accountingKeys.setUserManualAccountingConfig],

		onSuccess: () => {
			queryClient.invalidateQueries([accountingKeys.getUserManualAccountingConfig])
			setToast({
				message: 'operation-success',
				show: true,
			})
			onSuccess()
		},
	})
}

export const useGetUserManualAccountingConfig = (userId) => {

	return useQuery({
		queryFn: () => normalFetch(`banking/manual/admin/config/${userId}`),
		queryKey: [accountingKeys.getUserManualAccountingConfig],
		enabled: !!userId,
		onSuccess: () => {
		},
	})
}